<template>
    <div class="clearfix" style="padding-bottom: 20px;">
        <div class="col-md-6">
            <div class="form-group">
                <label class="control-label">User</label>
                <list v-model="model.user_id" :list="users" :usekey="true" :value="current"></list>
            </div>
            <div class="split-fields">
                <div class="form-group">
                    <label for="company_date_after" class="control-label">Companies After Date</label>
                    <datepicker input-class="form-control" format="dd/MM/yyyy" id="company_date_after" type="text" v-model="model.company.date.after"></datepicker>
                </div>
                <div class="form-group">
                    <label for="company_date_before" class="control-label">Companies Before Date</label>
                    <datepicker input-class="form-control" format="dd/MM/yyyy" id="company_date_before" type="text" v-model="model.company.date.before"></datepicker>
                </div>
            </div>
            <div class="split-fields">
                <div class="form-group">
                    <label class="control-label tag-label">Company Tags</label>
                    <input-tag :tags="model.company.tags"></input-tag>
                </div>
                <div class="form-group">
                    <label class="control-label tag-label">Company doesn't have Tags</label>
                    <input-tag :tags="model.company.minustags"></input-tag>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="split-fields">
                <div class="form-group">
                    <label for="invoice_date_after" class="control-label">Invoices After Date</label>
                    <datepicker input-class="form-control" format="dd/MM/yyyy" id="invoice_date_after" type="text" v-model="model.invoice.date.after"></datepicker>
                </div>
                <div class="form-group">
                    <label for="invoice_date_before" class="control-label">Invoices Before Date</label>
                    <datepicker input-class="form-control" format="dd/MM/yyyy" id="invoice_date_before" type="text" v-model="model.invoice.date.before"></datepicker>
                </div>
            </div>
            <div class="split-fields">
                <div>
                  <div class="form-group">
                      <label class="control-label tag-label">Invoice Tags</label>
                      <input-tag :tags="model.invoice.tags"></input-tag>
                  </div>
                  <div class="form-group">
                    <label class="control-label tag-label">Check if there are any invoices?</label>
                    <select v-model="model.has_invoices" >
                      <option value="yes">yes</option>
                      <option value="no">no</option>
                    </select>
                    <label class="control-label tag-label">Check if there are any payments?</label>
                    <select v-model="model.has_paid" >
                      <option value="yes">yes</option>
                      <option value="no">no</option>
                    </select>
                  </div>
                </div>
                <div class="split-fields limit-results">
                    <div class="form-group">
                        <label class="control-label tag-label">Limit Results</label>
                        <input type="number" v-model="model.limit">
                    </div>
                    <div class="form-group">
                        <label class="control-label tag-label">Offset Results</label>
                        <input type="number" v-model="model.offset">
                    </div>
                    <button class="btn btn-secondary" @click="nextBatch">Next Batch</button>
                </div>
            </div>
        </div>
        <div class="pull-right" style="padding-right: 20px;">
            <button @click="update" class="btn btn-primary">Update</button>
            <button @click="doexport" class="btn btn-primary">Export</button>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import InputTag from "../../components/InputTag";
    export default {
        name: "company-filters",
        props: {
            users: '',
            current: '',
            default_msg: 'Search all users',
        },
        components: {
            Datepicker,
            InputTag
        },
        data() {
            return {
                model: {
                    export: false,
                    has_paid: "yes",
                    has_invoices: "yes",
                    limit: 25,
                    offset: 0,
                    user_id: this.current,
                    company: {
                        // owner: '',
                        date: {
                            after: '',
                            before: '',
                        },
                        tags: [],
                        minustags: ['Cancelled']
                    },
                    invoice: {
                        date: {
                            after: '',
                            before: '',
                        },
                        tags: [],
                        minustags: []
                    }
                }
            }
        },
        created() {
        },
        methods: {
            nextBatch() {
                this.model.offset += parseInt(this.model.limit);
                this.update();
            },
            update() {
              this.model.export = false;
              this.$eventHub.$emit('my-company-listPushFilters', this.model);
            },
            doexport() {
                this.model.export = true;
                this.axios.post('/company/search/get-list', this.model).then((response) => {
                  // console.log(response);
                  // console.log(response.data);
                    window.location = response.data.url;
                });
            }
        }
    }
</script>

<style>
    .limit-results {
        border: 1px solid #ccc;
        padding: 15px;
        width: 49%;
        display: inline-block;
        margin-bottom: 10px;
    }
    .form-group .bootstrap-tagsinput .tag {
        color: #333;
    }
    .form-group .tag-label {
        display: block;
    }
</style>